import { showToast } from './toaster';

export const requestMicrophoneAccess = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    // If you need to use the stream for something (like audio processing), you can do it here
    // console.log('Microphone access granted:', stream);
  } catch (err) {
    console.error('Error accessing microphone:', err);
    showToast(
      'Microphone access denied. Please enable microphone access in your browser settings.',
      'error'
    );
  }
};

export const requestNotificationPermission = async () => {
  // Check the current permission state
  if (Notification.permission === 'granted') {
    // console.log('Notification permission already granted.');
    return true; // Permission is already granted
  }
  if (Notification.permission === 'denied') {
    // console.log('Notification permission denied.');
    return false; // Permission is denied
  }
  // Request permission from the user
  const permission = await Notification.requestPermission();
  if (permission === 'granted') {
    // console.log('Notification permission granted.');
    return true; // Permission granted
  }
  // console.log('Notification permission denied.');
  return false; // Permission denied
};
